import type { ReactNode } from "react";
import Title from "../UI/Title";
import styles from "./PilotageHeader.module.css";

interface PilotageHeaderProps {
  title: string;
  actions?: ReactNode;
}

/** Titre d'un onglet du pilotage, avec ses actions (export…) à droite. */
export default function PilotageHeader({
  title,
  actions,
}: PilotageHeaderProps) {
  return (
    <div className={styles.header}>
      <Title variant="kilo" weight="bold">
        {title}
      </Title>
      {actions && <div className={styles.actions}>{actions}</div>}
    </div>
  );
}
